/**
 * Parse JSON without throwing on malformed input (e.g. corrupted localStorage).
 * Returns `fallback` when the value is null/undefined or not valid JSON.
 * Valid input behaves exactly like JSON.parse.
 */
export const safeJsonParse = (value, fallback = null) => {
  if (value === null || value === undefined) return fallback;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export default safeJsonParse;
